import React, { Component } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import nakkiran from "../../images/about/our-leader-team/Artboard 2.webp"
import catherine from '../../images/about/our-leader-team/Catherine Natt.webp'
import sven from '../../images/about/our-leader-team/Sven Tang.webp'
import jimmy from "../../images/about/our-leader-team/Jimmy Susanto.webp"
import YuniarLinda from '../../images/about/our-leader-team/Yuniar Linda.jpg'
import LutfhiZarkasyi from '../../images/about/our-leader-team/Lutfhi Zarkasyi.webp'
import AntonHidayat from '../../images/about/our-leader-team/Anton Hidayat.webp'
import WijayaAndre from '../../images/about/our-leader-team/Wijaya Andre.jpeg'
import WidiantyOey from '../../images/about/our-leader-team/Widianty Oey.jpeg'
import VonnyWilianti from '../../images/about/our-leader-team/Vonny Wilianti.webp'
import CatharinaPalupi from '../../images/about/our-leader-team/Catharina Palupi.png'
import RyandinaAyusavitri from '../../images/about/our-leader-team/Ryandina Ayusavitri.png'

const content = [
  {
    image: YuniarLinda,
    name: "Yuniar Linda",
    title: "Director in Charge SBU Biopharma & CBO",
    idDetail: 1
  },
  {
    image: nakkiran,
    name: "Nakkiran Saravanakumar",
    title: "IGK Director",
    idDetail: 2,
  },
  {
    image: RyandinaAyusavitri,
    name: "Ryandina Ayusavitri",
    title: "Director",
    idDetail: 3,
  },
  {
    image: jimmy,
    name: "Jimmy Susanto",
    title: "COO",
    idDetail: 4,
  },
  {
    image: sven,
    name: "Sven Tang",
    title: "CMO",
    idDetail: 5,
  },
  {
    image: AntonHidayat,
    name: "Anton Hidayat",
    title: "Head of RA SBU Biopharma",
    idDetail: 6,
  },
  {
    image: LutfhiZarkasyi,
    name: "Lutfhi Zarkasyi",
    title: "Head of Quality SBU Biopharma",
    idDetail: 7,
  },
  {
    image: WijayaAndre,
    name: "Wijaya Andre",
    title: "Commercial GM & MA Coordinator",
    idDetail: 8,
  },
  {
    image: CatharinaPalupi,
    name: "Catharina Palupi",
    title: "Commercial GM",
    idDetail: 9,
  },
  {
    image: catherine,
    name: "Catherine Natt",
    title: "Commercial Singapore, Malaysia GM & Supply Chain GM",
    idDetail: 10,
  },
  {
    image: VonnyWilianti,
    name: "Vonny Wilianti",
    title: "BD&L Senior Manager",
    idDetail: 11
  },
  {
    image: WidiantyOey,
    name: "Widianty Oey",
    title: "IT Head SBU Biopharma",
    idDetail: 12
  }
]

class TeamSliderCustom extends Component {
  render() {
    const settings = {
      // dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      responsive: [
        {
          breakpoint: 2560,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }
    return (
      <>
        <Slider
          {...settings}
          className="dlab-team11-area dots-theme dots-long d-primary btn-style-1"
        >
          {/* {content.map((item, id) => (
                        <div key={id} class="item wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div class="dlab-box dlab-team11">
                                <div class="dlab-media dlab-img-effect custom-size">                                   
                                    <img src={item.image} alt="team-img" />
                                </div>
                                <div class="dlab-info">
                                    <h4 class="dlab-title">{item.name}</h4>
                                    <span class="dlab-position">{item.title}</span>
                                </div>
                            </div>
                        </div>
                    ))} */}
          {content.map((item, id) => {
            console.log(item)
            return (
              <div
                key={id}
                class="item wow fadeInUp"
                data-wow-duration="2s"
                data-wow-delay="0.2s"
              >
                <div class="dlab-box dlab-team11">
                  <div class="dlab-media dlab-img-effect custom-size">
                    {/* {item.idDetail === 5 || item.idDetail === 9 ? (
                      <img
                        src={item.image}
                        alt="team-img"
                        style={{ transform: "scaleX(-1)" }}
                      />
                    ) : (
                      <img src={item.image} alt="team-img" />
                    )} */}
                    <img src={item.image} alt="team-img" />
                  </div>
                  <div class="dlab-info">
                    <h4 class="dlab-title">{item.name}</h4>
                    <span class="dlab-position">{item.title}</span>
                  </div>
                </div>
              </div>
            )
          })}
        </Slider>
      </>
    )
  }
}
export default TeamSliderCustom
